module.exports = __webpack_public_path__ + "media/images/icons/icon_round_three_blue-ca29d8048e408417da1aaa30834a1df0.svg";